<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header *ngIf="dialog_icon">
    <div class="inline-icon" [inlineSVG]="dialog_icon"></div>
  </header>
  <p *ngFor="let text of texts" [langkey]="text"></p>
  <footer class="buttons" [class.in_column]="!buttons_in_row">
    <a *ngFor="let btn of buttons; let i = index" class="btn" [class.action]="highlighted_button_indices.indexOf(i) >= 0"
      [class.goback]="i===secondery_button_index " (click)="btn.onClick(dialogRef)">
      <span [langkey]="btn.langkey"></span>
      <ng-container *ngIf="btn.icon">
        <div class="inline-icon" [inlineSVG]="btn.icon" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      </ng-container>
    </a>
  </footer>
</div>